import * as microsoftTeams from '@microsoft/teams-js'
import { apiClient } from './api'

const API_URL = import.meta.env.VITE_API_URL || ''

/**
 * Teams SSO flow:
 * 1. Call getAuthToken() — Teams returns an SSO token silently (no popup, no redirect)
 * 2. Exchange token with backend via POST /api/auth/teams-sso (OBO flow on server)
 * 3. Store the returned session token in localStorage
 */
export async function handleTeamsSSO(): Promise<string> {
  // Step 1: Get SSO token from Teams silently
  const teamsToken = await microsoftTeams.authentication.getAuthToken()

  // Step 2: Exchange with backend (backend does OBO → Graph to get user info)
  const response = await fetch(`${API_URL}/api/auth/teams-sso`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ teams_token: teamsToken }),
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.detail || `Teams SSO failed: ${response.status}`)
  }

  const data = await response.json()
  const accessToken = data.access_token

  // Step 3: Store token in the format authService expects so isAuthenticated() returns true
  localStorage.setItem('auth_state', JSON.stringify({ isAuthenticated: true, token: accessToken }))
  apiClient.setAuthToken(accessToken)

  return accessToken
}
